module.exports = __webpack_public_path__ + "img/scene-challenger.6dffae1c.svg";